import { render, staticRenderFns } from "./PasswordResetRequestForm.vue?vue&type=template&id=4613aca4"
import script from "./PasswordResetRequestForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./PasswordResetRequestForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports